import './Overlay-9c58a079.css';

var classes = {"Overlay":"prc-Overlay-Overlay-dVyJl","overlay-appear":"prc-Overlay-overlay-appear-DGY3B"};

export { classes as default };
